export default __webpack_public_path__ + "static/media/editicon.4ce2a9cc.svg";